import { render } from "./DmeArrow.vue?vue&type=template&id=bc33b958"
import script from "./DmeArrow.vue?vue&type=script&lang=ts"
export * from "./DmeArrow.vue?vue&type=script&lang=ts"
script.render = render

export default script